import { createContext, useContext, useEffect, useState } from "react";

// Light/dark lives on <html class="dark"> so Tailwind's `dark:` styles and the
// palette layer in index.css both read it. The choice is remembered per device;
// the guide itself opens light, whatever the phone is set to.
const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, isDark: theme === "dark" }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () =>
  useContext(ThemeContext) || { theme: "light", isDark: false, setTheme: () => {} };